<template>
  <div id="car-detail">
    <router-link to="/vehicles" class="flex justify-flex-end link">
      &lt; Regresar
    </router-link>

    <LastPurchaseDetails v-if="selectedVehicle.last_purchase" />
    <component :is="selectedVehicleTypeComponent" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Annuality from '@/components/Vehicle/Annuality'
import Balance from '@/components/Vehicle/Balance'
import Mixed from '@/components/Vehicle/Mixed'
import LastPurchaseDetails from '@/components/LastPurchaseDetails'

export default {
  name: 'Vehicle',
  components: {
    Annuality,
    Mixed,
    Balance,
    LastPurchaseDetails
  },
  computed: {
    ...mapGetters('saleOrderForm', ['selectedVehicle']),
    selectedVehicleTypeComponent: function () {
      if (this.selectedVehicle.contract_type === 'Saldo') {
        this.getCrossingProductsList()

        return 'Balance'
      }
      if (this.selectedVehicle.contract_type === 'Mixto') {
        this.getMixedProductsList()

        return 'Mixed'
      }
      this.getAnnualityProductsList()

      return 'Annuality'
    }
  },
  async beforeMount () {
    const vehicleId = this.$route.params.id

    await this.setSelectedVehicleId(vehicleId)

    if (!this.selectedVehicle.can_recharge) {
      this.$router.push('/vehicles')
    }
  },
  destroyed () {
    this.clearDraftSaleState()
  },
  methods: {
    ...mapActions('saleOrderForm', [
      'clearDraftSaleState',
      'setSelectedVehicleId'
    ]),
    ...mapActions('products', [
      'getCrossingProductsList',
      'getMixedProductsList',
      'getAnnualityProductsList'
    ])
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#car-detail {
  color: $grey;
  text-align: start;
  margin: 1rem 2rem;
}

.title {
  text-align: start;
  color: $grey;
}

.link {
  color: $blue;
  text-decoration: none;
  font-style: italic;
  width: 100%;
}

.card {
  border-radius: 25px;
  background-color: $white;
  width: 60%;
}

.card-section {
  padding: 1.25rem 2rem;
}

.vehicle-information {
  width: 25%;
}

.center-text {
  text-align: center;
}

.btn {
  font-size: 0.75rem;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  border: 1px solid $light-blue;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }

  &.accept {
    color: $white;
    margin-left: 1rem;
    background-color: $light-blue;
  }

  &.cancel {
    margin-right: 1rem;
    color: $light-blue;
    background-color: $white;
  }
}

hr {
  border: 1px solid $grey;
  margin-block-start: 1.25rem;
  margin-block-end: 1.25rem;
  margin-inline-start: 0;
  margin-inline-end: 0;
}

@media screen and (max-width: 60rem) {
  .link {
    display: none;
  }

  .card {
    width: 100%;
  }

  .vehicle-information {
    width: auto;
  }

  .btn {
    &.accept {
      margin-left: 0;
    }

    &.cancel {
      margin-right: 0;
    }
  }

  h2 {
    font-size: 1.25rem;
  }

  hr {
    margin-block-start: 0rem;
    margin-block-end: 0rem;
    margin-inline-start: 1.25rem;
    margin-inline-end: 1.25rem;
  }

  #car-detail {
    margin: 0.5rem 0.5rem;
  }

}
</style>
